'use client';
import type { FC } from 'react';
import { Button } from '@app/_components/button';
import { css } from '@styled-system/css';
import { Paragraph, VStack } from '@styled-system/jsx';
import appIcon from './assets/icon-app.svg';

type Props = {
  onClickAppLink: () => void;
};

export const PaywallSpContent: FC<Props> = ({ onClickAppLink }) => {
  return (
    <VStack alignItems="center" margin="0 auto 24px" maxWidth="100%" gap="0">
      <img
        src={appIcon}
        alt="テラーノベルアプリアイコン"
        width="52px"
        height="51"
        className={css({
          borderRadius: '10px',
          margin: 'auto',
          display: 'block',
        })}
      />
      <Paragraph
        fontSize="size_18"
        fontWeight="700"
        marginBottom="8px"
        marginTop="24px"
      >
        気になる続きはアプリで読める！
      </Paragraph>
      <Paragraph fontSize="size_14" color="accent.700" marginTop="16px">
        テラーノベルアプリならフォローやコメント、自分だけの作品を書くこともできます。
      </Paragraph>
      <Button marginTop="16px" onClick={onClickAppLink}>
        アプリで続きを読む
      </Button>
    </VStack>
  );
};
